import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { GroupActivityD1, GroupActivityD1Type } from "../../types/slices/groupActivitiD1Type";

const initialState: GroupActivityD1Type = {
    status: ApiStatus.FETCHED,
    groupActivitiesD1: [],
    errorMessage: undefined,
    selectedGroupActivityD1: {} as GroupActivityD1
};

const groupActivitiD1Slice = createSlice({
    name: "groupActivityD1",
    initialState,
    reducers: {
        onFetchGroupActivityD1(state, { payload }: { payload: GroupActivityD1[] }) {
            state.status = ApiStatus.FETCHED;
            state.groupActivitiesD1 = payload;
            state.errorMessage = undefined;
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload;
        },
        onSetSelectedGroupActivityD1(state, { payload }: { payload: GroupActivityD1 }) {
            state.selectedGroupActivityD1 = payload;
        },
    }
});

export const selectGroupActivityD1 = (state: RootState) => state.groupActivityD1Slice;
export default groupActivitiD1Slice.reducer;

export const {
    onFetchGroupActivityD1,
    changeStatus,
    onSetSelectedGroupActivityD1,
} = groupActivitiD1Slice.actions;